import { styled, Box, Typography } from '@mui/material';
import { pxToRem } from '~/theme/typography';

export const StyledMainContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '60px',
  width: '100%',
  maxWidth: '1196px',
  [theme.breakpoints.down('desktop')]: {
    flexDirection: 'column',
    maxWidth: '555px',
    gap: '12px',
  },
  [theme.breakpoints.down('tablet')]: {
    maxWidth: '327px',
  },
}));

type TStyledSubContainer = {
  type: 'advertise' | 'input';
};

export const StyledSubContainer = styled(Box)<TStyledSubContainer>(
  ({ theme, type }) => ({
    width: 'calc((100% - 121px) / 2 )',
    display: 'flex',
    flexDirection: 'column',
    gap: type === 'advertise' ? ' 32px' : '16px',
    [theme.breakpoints.down('desktop')]: {
      width: '100%',
      gap: '12px',
    },
  }),
);

export const login = {
  title: styled(Typography)(({ theme }) => ({
    fontWeight: 700,
    fontSize: pxToRem(20),
    color: theme.palette.primary.dark,
    marginBottom: '2px',
  })),
  subTitle: styled(Typography)(({ theme }) => ({
    fontWeight: 500,
    fontSize: pxToRem(16),
    color: theme.palette.text.primary,
    marginBottom: '8px',
  })),

  onePassStatusContainer: styled(Box)(({ theme }) => ({
    width: '100vw',
    height: '100vh',
    backgroundColor: 'white',
    position: 'fixed',
    zIndex: '2',
    top: '0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.grey[500],
    fontWeight: 700,
    fontSize: pxToRem(16),
    textAlign: 'center',
  })),
};

export const StyledLoginFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: theme.spacing(7),
  width: '100%',
  '& p, a': {
    color: theme.palette.grey[600],
  },
  [theme.breakpoints.down('desktop')]: {
    flexDirection: 'column',
  },
  [theme.breakpoints.down('tablet')]: {
    '& .MuiTypography-body1': {
      fontSize: pxToRem(12),
    },
    '& .MuiLink-underlineAlways': {
      fontSize: pxToRem(14),
    },
  },
}));
